import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";

export default {
  props: {
    mySpace: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
    };
  },
  created() {
    EventBus.$on(`${this.$options.name}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }
    });

    EventBus.$on(`${this.$options.name}-delete`, (data) => {
      if (data.id) {
        this.deleteItem();
      }
    });
  },

  methods: {
    deleteItem() {
      let postFunc = null;
      const formData = new FormData(this.$refs.renameFileForm);

      formData.append("myspace", this.mySpace);

      if (this.optionsData.extension) {
        //is file
        //add to update
        formData.append("file", this.optionsData.fileId);

        //post file
        postFunc = this.$axios.post(
          `${baseUrl}/${
            this.type === "removeFilePermanent"
              ? "fileForceDelete"
              : "filedelete"
          }`,
          formData
        );
      } else {
        //is folder
        //add to update
        formData.append("folder", this.optionsData.fileId);

        //post folder
        postFunc = this.$axios.post(
          `${baseUrl}/${
            this.type === "removeFilePermanent"
              ? "folderForceDelete"
              : "folderdelete"
          }`,
          formData
        );
      }

      postFunc
        .then((r) => {
          //update files
          EventBus.$emit("mobile-files-update", {});

          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });

          //reset the focus
          this.focus = false;
        })
        .catch((e) => {
          if (this.optionsData.extension) {
            errorDispatch(i18next.t("error.delete_file"));
          } else {
            errorDispatch(i18next.t("error.delete_folder"));
          }
        });
    },
  },

  computed: {
    isFile() {
      return this.optionsData.extension;
    },
  },
};
